// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".station-heat-type{position:absolute;top:50px;left:20px;z-index:9999}", ""]);
// Exports
module.exports = exports;
